<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<br/><p style="text-indent:00em;">Thanks to my grandson, Bailey, for his amazing imagination, which helped me write this book through the eyes of a child.</p>
<br/><p style="text-indent:00em;">Remember Bailey – there’s no tigers at the bottom of the bed, or sharks in the carpet – they actually all live in your imagination.</p>
<br/><p style="text-indent:00em;">Thank you to my wife, Angie, always there for me.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?29481d8f